/* Nova Kids Shop: el botón de Releasit trae sus colores en línea con !important,
   así que se los reemplazamos al aparecer para que sea redondo y del color de la tienda. */
(function () {
  var estilos = {
    'background': 'var(--nv-electrico)',
    'color': '#fff',
    'border-radius': '999px',
    'border': '0',
    'box-shadow': '0 14px 28px -14px rgba(14,154,154,.9)',
    'font-size': '17px',
    'font-family': "'Poppins', -apple-system, sans-serif",
    'font-weight': '700',
    'min-height': '58px'
  };
  function pintar(el) {
    for (var k in estilos) {
      if (el.style.getPropertyValue(k) !== estilos[k] || el.style.getPropertyPriority(k) !== 'important') el.style.setProperty(k, estilos[k], 'important');
    }
  }
  function revisar() { document.querySelectorAll('._rsi-buy-now-button').forEach(pintar); }
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return; pendiente = true;
    requestAnimationFrame(function () { pendiente = false; revisar(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  document.addEventListener('DOMContentLoaded', revisar);
  revisar();
})();
